import React from 'react';
import PropTypes from 'prop-types';
import { StyledHead, StyledTitle, StyledAction } from './styled';

const SectionHeading = ({ title, action, info }) => (
  <StyledHead>
    <StyledTitle>
      {title}
      {info}
    </StyledTitle>
    {action ? <StyledAction>{action}</StyledAction> : null}
  </StyledHead>
);

SectionHeading.propTypes = {
  title: PropTypes.node.isRequired,
  action: PropTypes.node,
  info: PropTypes.node,
};

SectionHeading.defaultProps = {
  action: null,
  info: null,
};

export default SectionHeading;
